import "./data/EstimateDemandModel";
import "./data/ActivityType";
export class DemandModelApi {
    constructor(url) {
        this.url = url;
    }
    async postEstimateLocations(options) {
        let url = `${this.url}estimate/locations`;
        let first = true;
        if (options.defaultActivityType) {
            url += first ? "?" : "&";
            first = false;
            url += `defaultActivityType=${options.defaultActivityType}`;
        }
        if (options.defaultCount) {
            url += first ? "?" : "&";
            first = false;
            url += `defaultCount=${options.defaultCount}`;
        }
        if (options.defaultDistance) {
            url += first ? "?" : "&";
            first = false;
            url += `defaultDistance=${options.defaultDistance}`;
        }
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(options.data),
            signal: options.signal,
            headers: {
                "Content-Type": "application/json"
            },
        });
        return await response.json();
    }
}
